import {PauseCircleOutlined} from '@ant-design/icons';
import {Switch} from '@ds/components';
import {useEffect, useRef} from 'react';

type AreaStatusCardProps = {
  isActive: boolean;
  onChange: () => void;
  onClose: () => void;
};

const AreaStatusCard: React.FC<AreaStatusCardProps> = ({isActive, onChange, onClose}) => {
  const cardRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const handlePointerDown = (event: PointerEvent) => {
      if (!cardRef.current?.contains(event.target as Node)) {
        onClose();
      }
    };

    document.addEventListener('pointerdown', handlePointerDown);
    return () => document.removeEventListener('pointerdown', handlePointerDown);
  }, [onClose]);

  return (
    <aside
      ref={cardRef}
      className="absolute inset-x-4 bottom-20 z-10 flex items-center justify-between gap-3 rounded-2xl bg-white px-3 py-4 shadow-lg"
    >
      <div className="flex min-w-0 items-center gap-4">
        <span className="flex size-12 shrink-0 items-center justify-center rounded-full bg-destructive-surface">
          <PauseCircleOutlined
            aria-hidden
            className="text-subtitle-lg text-destructive"
          />
        </span>
        <span className="flex min-w-0 flex-col gap-0.5">
          <span className="text-body-sm-emphasis text-gray-09">غیرفعال‌کردن سرویس‌دهی</span>
          <span className="text-body-xs text-gray-07">
            سرویس‌دهی پیک فروشگاه را موقتاً غیرفعال کنید.
          </span>
        </span>
      </div>
      <Switch
        aria-label="فعال بودن سرویس‌دهی در محدوده انتخاب‌شده"
        checked={isActive}
        onChange={onChange}
        size="lg"
      />
    </aside>
  );
};

export default AreaStatusCard;
